export const convertArrayToObject = (
  array: { name: string; value: string }[]
): { [key: string]: string } => {
  return array.reduce<{ [key: string]: string }>((acc, { name, value }) => {
    acc[name] = value;
    return acc;
  }, {});
};

export function groupBy<T extends any, K extends keyof any>(
  array: T[],
  getKey: (item: T) => K
): Record<K, T[]> {
  return array.reduce<Record<K, T[]>>((acc, item) => {
    const key = getKey(item);
    (acc[key] ||= []).push(item);
    return acc;
    // eslint-disable-next-line @typescript-eslint/prefer-reduce-type-parameter
  }, {} as Record<K, T[]>);
}
